import axios from 'axios';

import AuthModel from '@/models/AuthModel';

export default class AppModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		this.hcaptcha_sitekey = 'e9c8a7dc-f9ca-437d-bbc5-ba9fa661b8a6';
		
		this.title = '';
		//this.project_url = 'https://new.bylex.info';
		this.project_url = 'https://bylex.info';
		
		this.auth = new AuthModel();
	}
	
	/**
	 * Set page title
	 */
	setPageTitle(title)
	{
		this.title = title;
		document.title = title;
	}
	
	pageReload()
	{
		document.location.reload();
	}
	
	/**
	 * Получение списка категорий портфолио
	 */
	async doGetWorksCategories(params = {})
	{
		try {
			const response = await axios.get('/api/data/works-categories', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление категории портфолио
	 */
	async doAddWorksCategory(params = {})
	{
		try {
			const response = await axios.post('/api/data/works-categories', params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о категории портфолио по ее id
	 */
	async doGetWorksCategory(works_category_id)
	{
		try {
			const response = await axios.get('/api/data/works-categories/' + works_category_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о категории портфолио по ее id
	 */
	async doEditWorksCategory(works_category_id, params = {})
	{
		try {
			const response = await axios.post('/api/data/works-categories/' + works_category_id, params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление категории портфолио по ее id
	 */
	async doDeleteWorksCategory(works_category_id)
	{
		try {
			const response = await axios.delete('/api/data/works-categories/' + works_category_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка записей портфолио
	 */
	async doGetWorks(params = {})
	{
		try {
			const response = await axios.get('/api/data/works', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление записи портфолио
	 */
	async doAddWork(params = {})
	{
		try {
			const response = await axios.post('/api/data/works', params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о записи портфолио по ее id
	 */
	async doGetWork(work_id)
	{
		try {
			const response = await axios.get('/api/data/works/' + work_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о записи портфолио по ее id
	 */
	async doEditWork(work_id, params = {})
	{
		try {
			const response = await axios.post('/api/data/works/' + work_id, params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление записи портфолио по ее id
	 */
	async doDeleteWork(work_id)
	{
		try {
			const response = await axios.delete('/api/data/works/' + work_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение изображений записи портфолио
	 */
	async doGetWorkImages(work_id)
	{
		try {
			const response = await axios.get('/api/data/works/' + work_id + '/images', {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Смена постера записи портфолио
	 */
	async doChangeWorkPoster(work_id, image_pkid)
	{
		try {
			const response = await axios.post('/api/data/works/' + work_id + '/change-poster/' + image_pkid, {}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление изображения записи портфолио
	 */
	async doDeleteWorkImage(work_id, image_pkid)
	{
		try {
			const response = await axios.delete('/api/data/works/' + work_id + '/images/' + image_pkid, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение видео записи портфолио
	 */
	async doGetWorkVideos(work_id)
	{
		try {
			const response = await axios.get('/api/data/works/' + work_id + '/videos', {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление видео записи портфолио
	 */
	async doDeleteWorkVideo(work_id, video_pkid)
	{
		try {
			const response = await axios.delete('/api/data/works/' + work_id + '/videos/' + video_pkid, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение 3d моделей записи портфолио
	 */
	async doGetWorkModels3d(work_id)
	{
		try {
			const response = await axios.get('/api/data/works/' + work_id + '/models3d', {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление 3d модели записи портфолио
	 */
	async doDeleteWorkModel3d(work_id, model3d_pkid)
	{
		try {
			const response = await axios.delete('/api/data/works/' + work_id + '/models3d/' + model3d_pkid, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка категорий блога
	 */
	async doGetBlogCategories(params = {})
	{
		try {
			const response = await axios.get('/api/data/blog-categories', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление категории блога
	 */
	async doAddBlogCategory(params = {})
	{
		try {
			const response = await axios.post('/api/data/blog-categories', params, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о категории блога по ее id
	 */
	async doGetBlogCategory(blog_category_id)
	{
		try {
			const response = await axios.get('/api/data/blog-categories/' + blog_category_id, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о категории блога по ее id
	 */
	async doEditBlogCategory(blog_category_id, params = {})
	{
		try {
			const response = await axios.post('/api/data/blog-categories/' + blog_category_id, params, {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление категории блога по ее id
	 */
	async doDeleteBlogCategory(blog_category_id)
	{
		try {
			const response = await axios.delete('/api/data/blog-categories/' + blog_category_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка записей блога
	 */
	async doGetBlog(params = {})
	{
		try {
			const response = await axios.get('/api/data/blog', {
				params,
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление записи блога
	 */
	async doAddBlogItem(params = {})
	{
		try {
			const response = await axios.post('/api/data/blog', params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о записи блога по ее id
	 */
	async doGetBlogItem(blog_item_id)
	{
		try {
			const response = await axios.get('/api/data/blog/' + blog_item_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о записи блога по ее id
	 */
	async doEditBlogItem(blog_item_id, params = {})
	{
		try {
			const response = await axios.post('/api/data/blog/' + blog_item_id, params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление записи блога по ее id
	 */
	async doDeleteBlogItem(blog_item_id)
	{
		try {
			const response = await axios.delete('/api/data/blog/' + blog_item_id, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение изображений записи блога
	 */
	async doGetBlogItemImages(blog_item_id)
	{
		try {
			const response = await axios.get('/api/data/blog/' + blog_item_id + '/images', {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Смена постера записи блога
	 */
	async doChangeBlogItemPoster(blog_item_id, image_pkid)
	{
		try {
			const response = await axios.post('/api/data/blog/' + blog_item_id + '/change-poster/' + image_pkid, {}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление изображения записи блога
	 */
	async doDeleteBlogItemImage(blog_item_id, image_pkid)
	{
		try {
			const response = await axios.delete('/api/data/blog/' + blog_item_id + '/images/' + image_pkid, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение файлов записи блога
	 */
	async doGetBlogItemFiles(blog_item_id)
	{
		try {
			const response = await axios.get('/api/data/blog/' + blog_item_id + '/files', {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление файла записи блога
	 */
	async doDeleteBlogItemFile(blog_item_id, file_pkid)
	{
		try {
			const response = await axios.delete('/api/data/blog/' + blog_item_id + '/files/' + file_pkid, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
}
